module.exports = __webpack_public_path__ + "img/academic-partnerships.aff88ff6.png";